import { useSelector } from 'react-redux';
import { buildUrlWithParams } from '../../utils/url.utils';
import useGetRequest from '../useGetRequest';
import moment from 'moment';

export default function useGetResponsiblesPreview(date) {
  const BASE_URL = useSelector((state) => state.BASE_URL);

  const formattedDate = date ? moment(date).format('YYYY-MM-DD') : null;

  const url = formattedDate
    ? buildUrlWithParams(`${BASE_URL}/dashboard/responsibles-preview`, {
        date: formattedDate,
      })
    : null;

  const { data, isLoading, error, mutate } = useGetRequest(url, 0);

  return {
    previewData: data || null,
    isLoading,
    error,
    refetch: mutate,
  };
}

